import axios from 'axios';
import { store } from 'store';
import { generalSliceActions } from 'store/slices/general/config';
import { selectToken } from 'store/slices/users/selectors';

const envBaseUrl = process.env.REACT_APP_BE_PROD_URL;
// process.env.NODE_ENV === 'production'
//   ? process.env.REACT_APP_BE_PROD_URL
//   : process.env.REACT_APP_BE_LOCAL_URL;
export const BASE_URL = localStorage.beUrl || envBaseUrl;

export const axiosInstance = axios.create({
  baseURL: BASE_URL,
});

axiosInstance.interceptors.request.use(
  (config) => {
    config.headers.Authorization = `Bearer ${selectToken(store.getState())}`;
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

axiosInstance.interceptors.response.use(
  (value) => value,
  (err) => {
    if (err.code === 'ERR_NETWORK') {
      store.dispatch(
        generalSliceActions.setAppMessage({
          type: 'error',
          message: err.message || 'Network error',
        }),
      );
      return Promise.reject(err);
    }
    if (err?.response?.status === 401 && localStorage.getItem('token')) {
      const config = err.config;
      config.headers.Authorization = `Bearer ${localStorage.getItem('token')}`;
      return axiosInstance(config);
    }
    if (err.code === 'ERR_NETWORK') {
      store.dispatch(
        generalSliceActions.setAppMessage({
          type: 'error',
          message: err.message,
        }),
      );
    }
    const message = err?.response?.data?.message;
    return Promise.reject(message ? message : err);
  },
);
